var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDriveSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 340",
    d: "M38.0435 52.3906L32.3866 46.7338L19.6587 59.4617C18.0966 61.0238 18.0966 63.5564 19.6587 65.1185C21.2208 66.6806 23.7534 66.6806 25.3155 65.1185L38.0435 52.3906Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 283",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 75.2842 37.7812)",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 282",
    cx: 13.3333,
    cy: 13.3333,
    r: 13.3333,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 65.856 37.7812)",
    fill: "#BDE9FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriveSearch);
export default __webpack_public_path__ + "static/media/IcDriveSearch.6a2e3edbd988c49286c76b15a447fd92.svg";
export { ForwardRef as ReactComponent };